<template>
    <div id="casiola-app-mobilepopup" class="app-popover-menu" :class="{ 'expanded': showMobile }"
        @click.prevent.stop="swipeDown">
        <div class="menu-wrapper">
            <transition name="slideUp" mode="out-in" appear>
                <!-- <div class="menu location" v-if="showMobile === 'destination'" @click.stop
                    v-touch:swipe.bottom="swipeDown">
                    <div class="swipe-bar" @click.stop="swipeDown"></div>
                    <div class="scroll-area" v-touch:swipe.stop>
                        <header>
                            <div class="title">
                                <h2>Where are you going?</h2>
                            </div>
                        </header>
                        <ul>
                            <li v-for="destination in destinations" :key="destination.id">
                                <button aria-label="set destination" @click.prevent="setDestination(destination.id)"
                                    :class="'loc-' + destination.id">
                                    <span>{{ destination.name }}</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div> -->
                <div class="menu date" :class="{ actionable: casiola.state.search.enforceFlow }"
                    v-if="showMobile === 'date'" @click.stop v-touch:swipe.bottom="swipeDown">
                    <div class="swipe-bar" @click.stop="swipeDown"></div>
                    <div class="scroll-area" v-touch:swipe.stop>
                        <header>
                            <div class="title">
                                <!-- <button aria-label="set destination" @click.prevent="showMobile = 'destination'">
                                    <i class="fas fa-arrow-left"></i>
                                </button> -->
                                <h2>When will you be there?</h2>
                            </div>
                            <span>
                                <strong>{{ destLabels }}{{ prettyDate ? ` • ${prettyDate}` : '' }}</strong>
                            </span>
                        </header>
                        <calendar :months="18" direction="col" :uid="casiola.state.selectedUnit?.id" v-model="casiola.state.baseFilters.date"/>
                    </div>
                    <div class="actions" v-if="casiola.state.search.enforceFlow">
                        <button aria-label="next" class="next" @click.stop="showMobile = 'guests'">Next</button>
                        <button aria-label="skip" class="skip" @click.stop="showMobile = 'guests'">Skip</button>
                    </div>
                </div>
                <div class="menu guests actionable" :class="{ actionable: casiola.state.search.enforceFlow }"
                    v-else-if="showMobile === 'guests'" @click.stop v-touch:swipe.bottom="swipeDown">
                    <div class="swipe-bar" @click.stop="swipeDown"></div>
                    <div class="scroll-area" v-touch:swipe.stop>
                        <header>
                            <div class="title">
                                <!-- <button aria-label="set date" @click.prevent="showMobile = 'date'">
                                    <i class="fas fa-arrow-left"></i>
                                </button> -->
                                <h2>Who's coming?</h2>
                            </div>
                            <span>
                                <strong>{{ destLabels }}{{ prettyDate ? ` • ${prettyDate}` : '' }}{{
                                        totalGuests ? ` •
                                                                    ${totalGuests} Guest${(totalGuests === 1) ? '' : 's'}` : ''
                                }}{{
        casiola.state.baseFilters.guests.pets ? ` • ${casiola.state.baseFilters.guests.pets}
                                    Pet${(casiola.state.baseFilters.guests.pets === 1) ? '' : 's'}` : ''
}}</strong>
                            </span>
                        </header>
                        <ul>
                            <li>
                                <div class="desc">
                                    <span class="label">Adults (12+)</span>
                                    <span class="body">Ages 13 and above</span>
                                </div>
                                <div class="counter">
                                    <vue-number-input v-model="casiola.state.baseFilters.guests.adults" :min="0"
                                        size="small" inline controls placeholder="0" :inputtable="false">
                                    </vue-number-input>
                                </div>
                            </li>
                            <li>
                                <div class="desc">
                                    <span class="label">Children</span>
                                    <span class="body">Ages 0 - 12</span>
                                </div>
                                <div class="counter">
                                    <vue-number-input v-model="casiola.state.baseFilters.guests.children" :min="0"
                                        size="small" inline controls placeholder="0" :inputtable="false">
                                    </vue-number-input>
                                </div>
                            </li>
                            <li>
                                <div class="desc">
                                    <span class="label">Dogs</span>
                                </div>
                                <div class="counter">
                                    <vue-number-input v-model="casiola.state.baseFilters.guests.pets" :min="0" :max="2"
                                        size="small" inline controls placeholder="0" :inputtable="false">
                                    </vue-number-input>
                                </div>
                                <div class="link">
                                    <a href="/guests/assistance-animals/" target="_blank">Bringing an assistance
                                        animal?</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="actions">
                        <button aria-label="next" class="next" @click.stop="search()"
                            v-if="casiola.state.search.enforceFlow">Search</button>
                        <button aria-label="next" class="next" @click.stop="toggleSearch(null)" v-else>Update</button>
                    </div>
                </div>
                <div class="menu filter actionable" v-else-if="showMobile === 'filter'" @click.stop
                    v-touch:swipe.bottom="swipeDown">
                    <div class="swipe-bar" @click.stop="swipeDown"></div>
                    <div class="scroll-area" v-touch:swipe.stop>
                        <ul>
                            <last-minute-filter></last-minute-filter>
                            <li>
                                <h3>Beds & bathrooms</h3>
                                <ul>
                                    <li>
                                        <label class="type--slider">
                                            <span>Beds</span>
                                            <vue-number-input v-model="casiola.state.advancedFilters.minimumBeds" :min="1"
                                                size="small" inline controls placeholder="0" :inputtable="false">
                                            </vue-number-input>
                                        </label>
                                    </li>
                                    <li>
                                        <label class="type--slider">
                                            <span>Bedrooms</span>
                                            <vue-number-input v-model="casiola.state.advancedFilters.minimumBedrooms" :min="1"
                                                size="small" inline controls placeholder="1" :inputtable="false">
                                            </vue-number-input>
                                        </label>
                                    </li>
                                    <li>
                                        <label class="type--slider">
                                            <span>Bathrooms</span>
                                            <vue-number-input v-model="casiola.state.advancedFilters.minimumBathrooms" :min="1"
                                                size="small" inline controls placeholder="1" :inputtable="false">
                                            </vue-number-input>
                                        </label>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <h3>Vacation rental type</h3>
                                <ul class="grid">
                                    <li v-for="ltype in casiola.state.collections.lodgingTypes" :key="ltype.id">
                                        <label class="type--checkbox">
                                            <input type="checkbox"
                                                v-model="casiola.state.advancedFilters.lodgingTypeIds"
                                                name="lodgingTypes" :value="ltype.id" />
                                            <span>{{ ltype.name }}</span>
                                        </label>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <h3>Resort</h3>
                                <ul class="grid">
                                    <li v-for="loc in locationsFiltered" :key="loc.id">
                                        <label class="type--checkbox">
                                            <input type="checkbox" v-model="casiola.state.advancedFilters.locationIds"
                                                name="locations" :value="loc.id" />
                                            <span>{{ loc.name }}</span>
                                        </label>
                                    </li>
                                </ul>
                            </li>
                            <amenities-filter></amenities-filter>
                            <li class="section-toggle privatepool">
                                <div class="body">
                                    <h3>Private pool</h3>
                                    <span>Show only properties with a private or community pool</span>
                                </div>
                                <toggle v-model="casiola.state.advancedFilters.privatePool"></toggle>
                            </li>
                            <li class="section-toggle petfriendly">
                                <div class="body">
                                    <h3>Pet friendly</h3>
                                    <span>Show only properties that are pet friendly</span>
                                </div>
                                <toggle v-model="casiola.state.advancedFilters.petFriendly"></toggle>
                            </li>
                        </ul>
                    </div>
                    <div class="actions">
                        <button aria-label="next" class="next" @click.stop="toggleSearch(null)">{{ casiola.state.results.total ? `Show
                                                    ${casiola.state.results.total} vacation rentals` : 'No results found'
                        }}</button>
                        <button aria-label="skip" class="skip" @click.stop="clear">Clear all</button>
                    </div>
                </div>
                <div class="menu sort actionable" v-else-if="showMobile === 'sort'" @click.stop
                    v-touch:swipe.bottom="swipeDown">
                    <div class="swipe-bar" @click.stop="swipeDown"></div>
                    <div class="scroll-area" v-touch:swipe.stop>
                        <header>
                            <div class="title">
                                <h2>
                                    <span>Sort results</span>
                                </h2>
                            </div>
                        </header>
                        <ul>
                            <li>
                                <ul>
                                    <li>
                                        <label class="type--checkbox">
                                            <input type="checkbox" v-model="sort" value="nightlyRate-ASC" />
                                            <span>Price low to high</span>
                                        </label>
                                    </li>
                                    <li>
                                        <label class="type--checkbox">
                                            <input type="checkbox" v-model="sort" value="nightlyRate-DESC" />
                                            <span>Price high to low</span>
                                        </label>
                                    </li>
                                    <li>
                                        <label class="type--checkbox">
                                            <input type="checkbox" v-model="sort" value="reviewRating-ASC" />
                                            <span>Guest rating</span>
                                        </label>
                                    </li>
                                    <li>
                                        <label class="type--checkbox">
                                            <input type="checkbox" v-model="sort" value="reviewCount-ASC" />
                                            <span>Number of reviews</span>
                                        </label>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div class="actions">
                        <button aria-label="next" class="next" @click.stop="toggleSearch(null)">Update</button>
                    </div>
                </div>
                <div class="menu social" v-else-if="showMobile === 'social' && casiola.state.selectedUnit" @click.stop
                    v-touch:swipe.bottom="swipeDown">
                    <div class="swipe-bar" @click.stop="swipeDown"></div>
                    <div class="scroll-area" v-touch:swipe.stop>
                        <header>
                            <img v-if="casiola.state.selectedUnit.thumbnail"
                                :src="casiola.state.selectedUnit.thumbnail" alt="">
                            <h5>{{ casiola.state.selectedUnit.headline }}</h5>
                        </header>
                        <main>
                            <ul>
                                <li class="to-clipboard">
                                    <a @click.prevent="urlToClipboard"><i class="fas fa-copy"></i> <span>Copy link<small>Copied to clipboard!</small></span></a>
                                </li>
                                <li>
                                    <ShareNetwork network="email" :title="casiola.state.selectedUnit.headline"
                                        :url="url"><i class="fas fa-envelope"></i> Email</ShareNetwork>
                                </li>
                                <li>
                                    <ShareNetwork network="whatsapp" :title="casiola.state.selectedUnit.headline"
                                        :url="url"><i class="fab fa-whatsapp"></i> Whatsapp</ShareNetwork>
                                </li>
                                <li>
                                    <ShareNetwork network="messenger" :title="casiola.state.selectedUnit.headline"
                                        :url="url"><i class="fab fa-facebook-messenger"></i> Messenger</ShareNetwork>
                                </li>
                                <li>
                                    <ShareNetwork network="facebook" :title="casiola.state.selectedUnit.headline"
                                        :url="url"><i class="fab fa-facebook"></i> Facebook</ShareNetwork>
                                </li>
                                <li>
                                    <ShareNetwork network="twitter" :title="casiola.state.selectedUnit.headline"
                                        :url="url"><i class="fab fa-twitter"></i> Twitter</ShareNetwork>
                                </li>
                            </ul>
                        </main>
                    </div>
                </div>
            </transition>
        </div>
    </div>
    <div id="casiola-app-mobilepopup-menu" class="app-popup-menu" :class="{ 'expanded': showModal }"
        @click.prevent.stop="showModal = null">
        <search-modal v-if="showModal === 'search'" @click.stop @close="showModal = null"></search-modal>
        <filter-modal v-else-if="showModal === 'filter'" @click.stop @close="showModal = null"></filter-modal>
    </div>
</template>
<script>
import gql from 'graphql-tag'
import { ref, watch, computed, defineAsyncComponent } from 'vue'
import { useCasiolaStore } from '@/store'
import { useQuery } from '@vue/apollo-composable'
import VueNumberInput from '@chenfengyuan/vue-number-input';
import SearchModal from '@/components/SearchModal.vue'
import FilterModal from '@/components/FilterModal.vue'
import Toggle from '@vueform/toggle'
import LastMinuteFilter from '@/components/LastMinuteFilter.vue';
import AmenitiesFilter from '@/components/AmenitiesFilter.vue'
const Calendar = defineAsyncComponent(() => import('@/components/Calendar.vue'))

const query = gql`query Query {
  destinations {
    id
    name
    uri
  }
}`

export default {
    name: 'App',
    components: { VueNumberInput, SearchModal, FilterModal, Toggle, LastMinuteFilter, AmenitiesFilter, Calendar },
    setup() {
        // console.log('mobilepopup setup')
        // CASIOLA STORE
        const casiola = useCasiolaStore()

        // VARIABLES
        const destinations = ref([])
        const destinationsFiltered = computed(() => destinations.value.filter(d => d.id !== 4))

        // DROPDOWN
        const openSearch = () => {
            casiola.state.search.mobileSearch = 'location'
        }
        const showMobile = ref(null)
        const showModal = ref(null)
        const watchSwipe = ref(true)
        const toggleSearch = (key) => {
            if (showMobile.value === key) {
                watchSwipe.value = false
                showMobile.value = null
            } else {
                showMobile.value = key
                setTimeout(() => {
                    watchSwipe.value = true
                }, 500)
            }
        }
        const swipeDown = () => {
            if (watchSwipe.value) {
                toggleSearch(null)
            }
        }
        watch(() => casiola.state.search.mobileSearch, (value) => {
            if (value) {
                showMobile.value = value
                casiola.state.search.mobileSearch = false
            }
        })
        watch(() => casiola.state.search.modal, (value) => {
            if (value) {
                showModal.value = value
                casiola.state.search.modal = null
            }
        })
        watch(() => showMobile.value, (showMobile) => {
            if (showMobile) {
                document.body.style.overflowY = 'hidden'
            } else {
                document.body.style.overflowY = 'auto'
            }
        })

        // DESTINATIONS
        const onQueryResult = (data) => {
            // console.log('queryResults')
            destinations.value = data.destinations
        }
        const { result, onResult } = useQuery(query);
        const handleResult = (data) => {
            onQueryResult(data)
        };
        watch(result, () => {
            if (!result.value) {
                return;
            }
            handleResult(result.value);
        }, {
            immediate: true
        });
        onResult(({ data }) => {
            if (data) {
                onQueryResult(data)
            }
        });
        const setDestination = (dest) => {
            if (dest) {
                casiola.state.baseFilters.destinations = [dest]
            } else {
                casiola.state.baseFilters.destinations = []
            }
            if (!casiola.state.search.enforceFlow) {
                toggleSearch(null)
            } else {
                showMobile.value = 'date'
            }
        }
        const destLabels = computed(() => {
            return casiola.state.baseFilters.destinations.reduce((acc, el) => {
                const o = destinations.value.find(e => {
                    return e.id === el
                })
                if (o) {
                    acc.push(o.name)
                }
                return acc
            }, []).join(', ')
        })

        // DATE
        watch(() => casiola.state.baseFilters.date, (d) => {
            if (!Object.values(d).some(v => !v) && !casiola.state.search.enforceFlow) {
                toggleSearch(null)
            }
        }, { deep: true })
        const prettyDate = computed(() => {
			if (casiola.state.baseFilters.date.start && casiola.state.baseFilters.date.end) {
				const sm = casiola.state.baseFilters.date.start.toFormat('MMM')
				const sd = casiola.state.baseFilters.date.start.toFormat('d')
				const em = casiola.state.baseFilters.date.end.toFormat('MMM')
				const ed = casiola.state.baseFilters.date.end.toFormat('d')
				const end = (sm === em) ? ed : `${em} ${ed}`
				return `${sm} ${sd}-${end}`

			}
			return null
		})

        // GUESTS
        const guests = [
            { label: 'Adults (12+)', body: "Ages 13 and above", key: 'adults' },
            { label: 'Children', body: "Ages 0 - 12", key: 'children' },
            { label: 'Dogs', body: null, key: 'pets' }
        ]
        const totalGuests = computed(() => {
            return casiola.state.baseFilters.guests.adults + casiola.state.baseFilters.guests.children
        })

        // SORT
        const sort = computed({
            get: () => {
                return (casiola.state.sort.id && casiola.state.sort.dir) ? [`${casiola.state.sort.id}-${casiola.state.sort.dir}`] : []
            },
            set: (newVal) => {
                if (newVal.length) {
                    const pop = newVal.pop()
                    const arr = pop.split('-')
                    casiola.state.sort.id = arr[0]
                    casiola.state.sort.dir = arr[1]
                } else {
                    casiola.state.sort.id = null
                    casiola.state.sort.dir = null
                }
            }
        })

        // SEARCH
        const search = () => {
            let dest = '/all-destinations'
            if (casiola.state.baseFilters.destinations.length) {
                dest = destinations.value.find((d) => d.id === casiola.state.baseFilters.destinations[0]).uri
            }
            const url = new URL(`${window.location.protocol}//${window.location.hostname}${dest}/vacation-rentals`)
            casiola.state.baseFilters.destinations.length ? url.searchParams.append('destinationIds', casiola.state.baseFilters.destinations.join('+')) : null
            if (casiola.state.baseFilters.date.start) {
                url.searchParams.append('checkin', casiola.state.baseFilters.date.start.toFormat('yyyy-MM-dd'))
                url.searchParams.append('checkout', casiola.state.baseFilters.date.end.toFormat('yyyy-MM-dd'))
            }
            casiola.state.baseFilters.guests.adults ? url.searchParams.append('adults', casiola.state.baseFilters.guests.adults) : null
            casiola.state.baseFilters.guests.children ? url.searchParams.append('children', casiola.state.baseFilters.guests.children) : null
            casiola.state.baseFilters.guests.pets ? url.searchParams.append('pets', casiola.state.baseFilters.guests.pets) : null
            window.location.href = url
        }

        const url = ref(new URL(`${window.location.protocol}//${window.location.hostname}${casiola.state.selectedUnit ? casiola.state.selectedUnit.uri : ''}`))

        const urlToClipboard = (e) => {
            e.target.classList.toggle('copied', true)
            window.navigator.clipboard.writeText(url.value);
            setTimeout(() => {
                e.target.classList.toggle('copied', false)
            }, 2500)
        }

        // LOCATIONS
        const locationsFiltered = computed(() => {
            return casiola.state.collections.locations.filter(loc => !casiola.state.baseFilters.destinations.length || casiola.state.baseFilters.destinations.includes(loc.destinationId))
        })

        const clear = () => {
            casiola.state.advancedFilters.deal = null
            casiola.state.advancedFilters.minimumBeds = 1
            casiola.state.advancedFilters.maximumBeds = null
            casiola.state.advancedFilters.minimumBedrooms = 1
            casiola.state.advancedFilters.maximumBedrooms = null
            casiola.state.advancedFilters.minimumBathrooms = 1
            casiola.state.advancedFilters.maximumBathrooms = null
            casiola.state.advancedFilters.lodgingTypeIds = []
            casiola.state.advancedFilters.locationIds = []
            casiola.state.advancedFilters.petFriendly = null
            casiola.state.advancedFilters.privatePool = null
        }

        // OUTSIDE TRIGGER
        const trigger = document.getElementById('casiola-mmenu-trigger')
        if (trigger) {
            // trigger.addEventListener('click', function (e) {
            //     e.preventDefault()
            //     casiola.state.search.mobileSearch = 'destination'
            // })
        }

        return {
            casiola,
            showMobile,
            showModal,
            openSearch,
            swipeDown,
            destinations,
            destinationsFiltered,
            setDestination,
            guests,
            search,
            toggleSearch,
            prettyDate,
            destLabels,
            totalGuests,
            locationsFiltered,
            sort,
            url,
            urlToClipboard,
            clear
        }
    }
}
</script>
<style src="@/assets/vueform-slider.css">
</style>